module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10206.051ad2ef.jpg";